module.exports = __webpack_public_path__ + "fonts/ProximaNova-Light.051acd0f.woff2";